import { render, staticRenderFns } from "./activityRecord.vue?vue&type=template&id=55471fc5&scoped=true"
import script from "./activityRecord.vue?vue&type=script&lang=js"
export * from "./activityRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55471fc5",
  null
  
)

export default component.exports